export const ResponseStatusEnum = {
  SUCCESS: 200 || 201,
  CREATE: 201,
  ERROR: 400 || 404,
  DATA_NOT_FOUND: 404,
  DB_SERVER_ERROR: 500,
  DUPLICATE: 409,
  ACCEPTED: 202,
  ACCESS_DENIED: 403,
  NO_DATA_FOUND: "No Data Found!",
  DEFAULT_DATE: "2021-04-13T18:30:00.000Z",
  NOT_FOUND: 404,
};

export const religian = ["Hindu", "Muslim", "Christian", "Jain"];
export const nationality = ["Indian", "Canadian", "Pakistani", "Australian"];
export const relation = [
  "Mother",
  "Father",
  "Sister",
  "Brother",
  "Wife",
  "Husband",
];

export const vendor = ["Vendor1", "Vendor2", "Vendor3"];
export const leaveStatus = ["ALL", "Pending", "Approved", "Rejected"];

export const LIST_OF_ISSUES = [
  { value: 1, label: "Forget Password Issue" },
  { value: 2, label: "Device Issue" },
];

export const ListOfDevice = [
  { value: "Laptop", label: "Laptop" },
  { value: "Mouse", label: "Mouse" },
  { value: "Bag", label: "Bag" },
  { value: "Mouse Pad", label: "Mouse Pad" },
  { value: "KeyBoard", label: "KeyBoard" },
  { value: "Charger", label: "Charger" },
];

export const LIST_OF_CLIENT_DESIGNATION = [
  { value: "Director", label: "Director" },
  {
    value: "CEO",
    label: "Chief_Executive_Officer_(CEO)",
  },
  { value: "President", label: "President" },
  { value: "Vice President", label: "Vice President" },
  {
    value: "Business Development Executive",
    label: "Business Development Executive",
  },
  {
    value: "Business Development Manager",
    label: "Business Development Manager",
  },
  {
    value: "Human Resource",
    label: "Human Resource",
  },
  { value: "Talent Acquisition", label: "Talent Acquisition" },
  { value: "Others", label: "Others" },
];

export const ProjectTypes = [
  { value: "Fixed Project", label: "Fixed Project" },
  { value: "Dedicated Project", label: "Dedicated Project" },
];
export const NO_DATA_FOUND = "No Data Found!";
export const DEFAULT_DATE = "2021-04-13T18:30:00.000Z";
export const TIME_ZERO = "00:00:00";

export const NationalityOptions = [
  {
    value: "Indian",
    label: "Indian",
  },
  {
    value: "Canadian",
    label: "Canadian",
  },
  {
    value: "Pakistani",
    label: "Pakistani",
  },
  {
    value: "Australian",
    label: "Australian",
  },
];
export const RelationOption = [
  {
    value: "Mother",
    label: "Mother",
  },
  {
    value: "Father",
    label: "Father",
  },
  {
    value: "Sister",
    label: "Sister",
  },
  {
    value: "Brother",
    label: "Brother",
  },
  {
    value: "Wife",
    label: "Wife",
  },
  {
    value: "Husband",
    label: "Husband",
  },
];
export const ReligionOption = [
  {
    value: "Hindu",
    label: "Hindu",
  },
  {
    value: "Muslim",
    label: "Muslim",
  },
  {
    value: "Christian",
    label: "Christian",
  },
  {
    value: "Jain",
    label: "Jain",
  },
];
export const GenderOption = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },
];
export const designationDetails = [
  {
    value: "Node Js",
    label: "Node Js",
  },
  {
    value: "Vue Js",
    label: "Vue Js",
  },
  {
    value: "React Js",
    label: "React Js",
  },
  {
    value: "Python",
    label: "Python",
  },
  {
    value: "MERN",
    label: "MERN",
  },
  {
    value: "MEAN",
    label: "MEAN",
  },
  {
    value: "Angular",
    label: "Angular",
  },
  {
    value: "BDE",
    label: "BDE",
  },
  {
    value: "HR",
    label: "HR",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export const roleDetails = [
  {
    value: "HR",
    label: "HR",
  },
  {
    value: "Employee",
    label: "Employee",
  },
  {
    value: "BDE",
    label: "BDE",
  },
];

export const statusDetails = [
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "InActive",
    label: "InActive",
  },
  {
    value: "ALL",
    label: "ALL",
  },
];
export const attachments = [
  { value: "Education", label: "Education" },
  { value: "Aadhar Card", label: "Aadhar Card" },
  { value: "Pan Card", label: "Pan Card" },
  { value: "Driving License", label: "Driving License" },
];

export const LEAVE_TYPES = [
  { label: "Full", value: "Full" },
  { label: "Half", value: "Half" },
];

export const leaveCategoryOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Casual Leave", value: "CL" },
  { label: "Comp Of Leave", value: "COL" },
  { label: "LWP Leave", value: "LWP" },
];

export const leaveStatusOptions = leaveStatus.map(status => ({
  label: status,
  value: status
}));

export const leaveTypeOptions = [
  { label: "Full", value: "Full" },
  { label: "Half", value: "Half" },
];

export const LEAVE_CATEGORIES = [
  { label: "Casual Leave", value: "CL" },
  { label: "Comp Of Leave", value: "COL" },
  { label: "Leave Without Pay", value: "LWP" },
];

export const LEAVE_STATUS_ENUM = [
  { value: "ALL", label: "ALL" },
  { value: "Pending", label: "Pending" },
  { value: "Approved", label: "Approved" },
  { value: "Rejected", label: "Rejected" },
]

export const BDEStatus = [
    {
      value: "Selected",
      label: "Selected",
    },
    {
      value: "Rejected",
      label: "Rejected",
    },
    {
      value: "OnHold",
      label: "OnHold",
    },
];

export const BDERound = [
  {
    value: "Screening Round",
    label: "1(Screening Round)",
  },
  {
    value: "Second Round",
    label: "2",
  },
  {
    value: "Third Round",
    label: "3",
  },
  {
    value: "Fourth Round",
    label: "4",
  },
  {
    value: "Fifth Round",
    label: "5",
  },
];

export const BDEDuration = Array.from({ length: 10 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1}+`,
}));

export const developmentData = [
  { label: "BE (Backend)", value: "BE" },
  { label: "FE (Frontend)", value: "FE" },
];

export const MinutesOption = [
    {
      label: "00",
      value: "00",
    },
    {
      label: "15",
      value: "15",
    },
    {
      label: "30",
      value: "30",
    },
    {
      label: "45",
      value: "45",
    },
    {
      label: "60",
      value: "60",
    },
];
  
export const TimeSheetDuration = Array.from({ length: 10 }, (_, i) => ({
  value: i + 1,
  label: `${i+1} ${i > 0 ? ` months` : ` month`}`,
}));
export const Hours = Array.from({ length: 10 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1} Hr`,
}));
export const TaskStatus = [
    {
      value: "Completed",
      label: "Complete",
    },
    {
      value: "Pending",
      label: "Pending",
    },
  ];

export const DailyTakStatus = [
  ...TaskStatus,
  {
    value: "On Process",
    label: "On Process",
  },
];

export const ResourceType = [
  { value: "Laptop", label: "Laptop" },
  { value: "Mouse", label: "Mouse" },
  { value: "Bag", label: "Bag" },
  { value: "Mouse Pad", label: "Mouse Pad" },
  { value: "KeyBoard", label: "KeyBoard" },
  { value: "Charger", label: "Charger" },
];

export const OsType = [
  {
    value: "Window",
    label: "Window",
  },
  {
    value: "Linux",
    label: "Linux",
  },
  {
    value: "IOS",
    label: "IOS",
  },
];

export const BrandName = [
  {
    value: "HP",
    label: "HP",
  },
  {
    value: "Dell",
    label: "Dell",
  },
  {
    value: "Apple",
    label: "Apple",
  },
  {
    value: "Others",
    label: "Others",
  },
];

export const PaymentModeOption = [
  {
    value: "Cash",
    label: "Cash",
  },
  {
    value: "Online",
    label: "Online",
  },
  {
    value: "Cheque",
    label: "Cheque",
  },
];

export const StorageTypeOption = [
  {
    value: "SSD",
    label: "SSD",
  },
  {
    value: "HDD",
    label: "HDD",
  },
];
  
export const DamagedResourceStatus = [
    {
      value: "Damage",
      label: "Damage",
    },
    {
      value: "On Process",
      label: "On Process",
    },
    {
      value: "Repair",
      label: "Repair",
    },
    {
      value: "Success",
      label: "Success",
    },
];
  
export const SingleOptions = [
    { value: "Laptop", label: "Laptop" },
    { value: "Mouse", label: "Mouse" },
    { value: "Keyboard", label: "Keyboard" },
    { value: "CPU", label: "CPU" },
    { value: "Monitar", label: "Monitar" },
];
  
export const TypeOfIssue = [
  {
    value: "Device issue",
    label: "Device issue",
  },
  {
    value: "Forgot password",
    label: "Forgot password",
  },
  {
    value: "Other",
    label: "Other",
  },
]; 